import { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

import type { ClassName } from "../../types";

type Props = {
  isActive?: boolean;
} & ClassName;

export const Item = ({
  children,
  isActive,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <li
      className={twMerge(
        "text-fiord flex items-center text-sm font-medium",
        isActive && "text-dodgerBlue pointer-events-none font-semibold",
        className
      )}
    >
      {children}
    </li>
  );
};
